// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-container {
  background-color: var(--color-gray-50) !important;
  border-radius: 12px;
  box-shadow: 0 2px 8px var(--color-shadow-light);
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  width: 100% !important;
  margin: 0 !important;
  min-height: calc(100vh - 60px);
  max-height: calc(100vh - 60px);
  height: calc(100vh - 60px);
  box-sizing: border-box;
}

/* Asegurar que los estilos específicos de ruta tengan prioridad */
.content-container.route-usuario {
  width: 100% !important; /* Ocupa todo el ancho */
  max-width: 800px !important; /* Limita el ancho máximo solo para esta ruta */
  margin: 0 auto !important; /* Centra si es más estrecho que el contenedor */
  border-radius: 12px; /* Mantener bordes redondeados */
  box-shadow: 0 2px 8px var(--color-shadow-light) !important; /* Mantener sombra */
}

.content-container.variant-default {
  background-color: var(--color-gray-50) !important; /* Gris muy claro */
}

.content-container.variant-dark {
  background-color: var(--color-gray-800);
  color: var(--color-text-white);
}

.content-container.variant-white {
  background-color: #ffffff !important;
  box-shadow: none !important; /* Sin sombra — el contraste blanco vs página gris ya separa visualmente y la sombra creaba una línea fantasma encima del top edge */
}

.content-container.padding-none {
  padding: 0;
}

.content-container.padding-sm {
  padding: var(--spacing-4);
}

.content-container.padding-md {
  padding: var(--spacing-6);
  box-sizing: border-box;
  margin: 0 !important; /* Sin márgenes externos */
}

.content-container.padding-lg {
  padding: var(--spacing-8);
}

/* Responsive padding adjustments */
@media (max-width: 575px) {
  .content-container.padding-sm {
    padding: var(--spacing-3);
  }

  .content-container.padding-md {
    padding: var(--spacing-4);
  }

  .content-container.padding-lg {
    padding: var(--spacing-6);
  }
}

@media (min-width: 576px) and (max-width: 1023px) {
  .content-container.padding-sm {
    padding: var(--spacing-4);
  }

  .content-container.padding-md {
    padding: var(--spacing-5);
  }

  .content-container.padding-lg {
    padding: var(--spacing-6);
  }
}

/* Smooth scrolling */
.content-container {
  scroll-behavior: smooth;
}

/* Ensure proper height calculation */
.content-container[style*="max-height"] {
  height: auto;
}

/* Force children to take full width */
.content-container > * {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}

/* Specifically target div.mt-4 and router-outlet inside content-container */
.content-container .mt-4,
.content-container router-outlet {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  display: block !important;
  box-sizing: border-box !important;
}

/* Force app-tutorials and all its children to full width */
.content-container app-tutorials,
.content-container app-tutorials > * {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  box-sizing: border-box !important;
}

/* Force blockchain and euros components to full width */
.content-container app-blockchain,
.content-container app-blockchain > *,
.content-container app-euros,
.content-container app-euros > * {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  box-sizing: border-box !important;
}

/* Force my-profile child components to full width */
.content-container app-investment-method,
.content-container app-investment-method > *,
.content-container app-user,
.content-container app-user > *,
.content-container app-configuration,
.content-container app-configuration > *,
.content-container app-change-password,
.content-container app-change-password > * {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 0 !important;
  box-sizing: border-box !important;
}

/* Asegurar que TODOS los content-containers mantengan bordes redondeados y sombra */
/* Esta regla tiene máxima prioridad para garantizar consistencia visual */
.content-container,
.content-container.scrollbar-custom,
.content-container.padding-md,
.content-container.padding-sm,
.content-container.padding-lg,
.content-container.padding-none,
.content-container.variant-default,
.content-container.variant-dark,
.content-container.route-usuario,
.content-container.route-metodo-inversion,
.content-container.route-resumen-financiero,
.content-container.route-documentos,
.content-container.menu-collapsed,
app-content-container .content-container,
app-content-container > .content-container {
  border-radius: 12px;
  box-shadow: 0 2px 8px var(--color-shadow-light) !important;
}


/* Override: cuando variant-white está activo, NO aplicar la sombra global */
/* La sombra "0 2px 8px ..." proyecta ~6px hacia arriba del elemento, generando una */
/* línea fantasma justo bajo el navbar en rutas con fondo blanco (cartera-digital/euros, etc.). */
/* Selectores triple-clase para ganar especificidad sobre la regla anterior. */
.content-container.variant-white,
.content-container.scrollbar-custom.variant-white,
.content-container.padding-md.variant-white,
.content-container.padding-sm.variant-white,
.content-container.padding-lg.variant-white,
.content-container.padding-none.variant-white,
.content-container.scrollbar-custom.padding-md.variant-white,
.content-container.scrollbar-custom.padding-sm.variant-white,
.content-container.scrollbar-custom.padding-lg.variant-white,
.content-container.scrollbar-custom.padding-none.variant-white,
app-content-container .content-container.variant-white,
app-content-container > .content-container.variant-white {
  box-shadow: none !important;
}

/* Adjust container width for specific routes */
/* Método de inversión - ocupa todo el ancho */
.content-container.route-metodo-inversion,
.content-container.scrollbar-custom.route-metodo-inversion,
.content-container.padding-md.route-metodo-inversion {
  width: 100% !important; /* Ocupa todo el ancho */
  max-width: none !important; /* Sin límite máximo */
  margin: 0 !important;
  border-radius: 12px; /* Mantener bordes redondeados */
  box-shadow: 0 2px 8px var(--color-shadow-light) !important; /* Mantener sombra */
}

/* Usuario - limita el ancho máximo pero ocupa todo si es menor */
.content-container.route-usuario,
.content-container.scrollbar-custom.route-usuario,
.content-container.padding-md.route-usuario,
.content-container.variant-default.route-usuario {
  width: 100% !important; /* Ocupa todo el ancho disponible */
  max-width: 800px !important; /* Limita el ancho máximo solo si es necesario */
  margin: 0 auto !important; /* Centra si es más estrecho que el contenedor */
  border-radius: 12px; /* Mantener bordes redondeados */
  box-shadow: 0 2px 8px var(--color-shadow-light) !important; /* Mantener sombra */
}

/* Dashboard - Resumen Financiero y Documentos - ocupa todo el ancho */
.content-container.route-resumen-financiero,
.content-container.scrollbar-custom.route-resumen-financiero,
.content-container.padding-md.route-resumen-financiero,
.content-container.route-documentos,
.content-container.scrollbar-custom.route-documentos,
.content-container.padding-md.route-documentos {
  width: 100% !important; /* Ocupa todo el ancho */
  margin: 0 !important;
  border-radius: 12px; /* Mantener bordes redondeados */
  box-shadow: 0 2px 8px var(--color-shadow-light) !important; /* Mantener sombra */
}

/* Support for menu-collapsed class from referral-panel */
.content-container.menu-collapsed {
  width: 100% !important; /* Ocupa todo el ancho del contenedor padre */
  padding: 0px 60px 0px 60px !important;
  margin: 0 !important;
  border-radius: 12px; /* Mantener bordes redondeados */
  box-shadow: 0 2px 8px var(--color-shadow-light) !important; /* Mantener sombra */
  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@media screen and (max-width: 1324px) {
  .content-container.menu-collapsed {
    width: 100% !important;
    padding: 0px 40px 0px 40px !important;
    margin: 0 !important;
    border-radius: 12px;
    box-shadow: 0 2px 8px var(--color-shadow-light) !important;
  }
}

/* ============================================================
   MOBILE OVERRIDE — este bloque va AL FINAL para ganar siempre
   en cascada sobre todas las reglas de ruta y alta especificidad.
   En mobile el border-radius y la sombra los gestiona
   navbar-router-container. El content-container hereda altura.
   ============================================================ */
@media screen and (max-width: 767px) {
  .content-container,
  .content-container.scrollbar-custom,
  .content-container.padding-md,
  .content-container.padding-sm,
  .content-container.padding-lg,
  .content-container.padding-none,
  .content-container.variant-default,
  .content-container.variant-white,
  .content-container.variant-dark,
  .content-container.route-usuario,
  .content-container.scrollbar-custom.route-usuario,
  .content-container.padding-md.route-usuario,
  .content-container.variant-default.route-usuario,
  .content-container.route-metodo-inversion,
  .content-container.scrollbar-custom.route-metodo-inversion,
  .content-container.padding-md.route-metodo-inversion,
  .content-container.route-resumen-financiero,
  .content-container.scrollbar-custom.route-resumen-financiero,
  .content-container.padding-md.route-resumen-financiero,
  .content-container.route-documentos,
  .content-container.scrollbar-custom.route-documentos,
  .content-container.padding-md.route-documentos,
  .content-container.menu-collapsed,
  app-content-container .content-container,
  app-content-container > .content-container {
    border-radius: 0 !important;
    box-shadow: none !important;
    min-height: 0 !important;
    max-height: 100% !important;
    height: 100% !important;
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared-ui/content-container/content-container.component.css"],"names":[],"mappings":"AAAA;EACE,iDAAiD;EACjD,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;EAC9B,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,kEAAkE;AAClE;EACE,sBAAsB,EAAE,wBAAwB;EAChD,2BAA2B,EAAE,+CAA+C;EAC5E,yBAAyB,EAAE,gDAAgD;EAC3E,mBAAmB,EAAE,gCAAgC;EACrD,0DAA0D,EAAE,oBAAoB;AAClF;;AAEA;EACE,iDAAiD,EAAE,mBAAmB;AACxE;;AAEA;EACE,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B,EAAE,oIAAoI;AACnK;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB,EAAE,0BAA0B;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mCAAmC;AACnC;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,4EAA4E;AAC5E;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA,2DAA2D;AAC3D;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,wDAAwD;AACxD;;;;EAIE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,oDAAoD;AACpD;;;;;;;;EAQE,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,oFAAoF;AACpF,0EAA0E;AAC1E;;;;;;;;;;;;;;;EAeE,mBAAmB;EACnB,0DAA0D;AAC5D;;;AAGA,4EAA4E;AAC5E,qFAAqF;AACrF,iGAAiG;AACjG,8EAA8E;AAC9E;;;;;;;;;;;;EAYE,2BAA2B;AAC7B;;AAEA,+CAA+C;AAC/C,8CAA8C;AAC9C;;;EAGE,sBAAsB,EAAE,wBAAwB;EAChD,0BAA0B,EAAE,sBAAsB;EAClD,oBAAoB;EACpB,mBAAmB,EAAE,gCAAgC;EACrD,0DAA0D,EAAE,oBAAoB;AAClF;;AAEA,iEAAiE;AACjE;;;;EAIE,sBAAsB,EAAE,mCAAmC;EAC3D,2BAA2B,EAAE,gDAAgD;EAC7E,yBAAyB,EAAE,gDAAgD;EAC3E,mBAAmB,EAAE,gCAAgC;EACrD,0DAA0D,EAAE,oBAAoB;AAClF;;AAEA,sEAAsE;AACtE;;;;;;EAME,sBAAsB,EAAE,wBAAwB;EAChD,oBAAoB;EACpB,mBAAmB,EAAE,gCAAgC;EACrD,0DAA0D,EAAE,oBAAoB;AAClF;;AAEA,yDAAyD;AACzD;EACE,sBAAsB,EAAE,6CAA6C;EACrE,qCAAqC;EACrC,oBAAoB;EACpB,mBAAmB,EAAE,gCAAgC;EACrD,0DAA0D,EAAE,oBAAoB;EAChF,qDAAqD;AACvD;;AAEA;EACE;IACE,sBAAsB;IACtB,qCAAqC;IACrC,oBAAoB;IACpB,mBAAmB;IACnB,0DAA0D;EAC5D;AACF;;AAEA;;;;;iEAKiE;AACjE;EACE;;;;;;;;;;;;;;;;;;;;;;;;;IAyBE,2BAA2B;IAC3B,2BAA2B;IAC3B,wBAAwB;IACxB,2BAA2B;IAC3B,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;EAChC;AACF","sourcesContent":[".content-container {\n  background-color: var(--color-gray-50) !important;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px var(--color-shadow-light);\n  overflow-y: auto;\n  overflow-x: hidden;\n  position: relative;\n  width: 100% !important;\n  margin: 0 !important;\n  min-height: calc(100vh - 60px);\n  max-height: calc(100vh - 60px);\n  height: calc(100vh - 60px);\n  box-sizing: border-box;\n}\n\n/* Asegurar que los estilos específicos de ruta tengan prioridad */\n.content-container.route-usuario {\n  width: 100% !important; /* Ocupa todo el ancho */\n  max-width: 800px !important; /* Limita el ancho máximo solo para esta ruta */\n  margin: 0 auto !important; /* Centra si es más estrecho que el contenedor */\n  border-radius: 12px; /* Mantener bordes redondeados */\n  box-shadow: 0 2px 8px var(--color-shadow-light) !important; /* Mantener sombra */\n}\n\n.content-container.variant-default {\n  background-color: var(--color-gray-50) !important; /* Gris muy claro */\n}\n\n.content-container.variant-dark {\n  background-color: var(--color-gray-800);\n  color: var(--color-text-white);\n}\n\n.content-container.variant-white {\n  background-color: #ffffff !important;\n  box-shadow: none !important; /* Sin sombra — el contraste blanco vs página gris ya separa visualmente y la sombra creaba una línea fantasma encima del top edge */\n}\n\n.content-container.padding-none {\n  padding: 0;\n}\n\n.content-container.padding-sm {\n  padding: var(--spacing-4);\n}\n\n.content-container.padding-md {\n  padding: var(--spacing-6);\n  box-sizing: border-box;\n  margin: 0 !important; /* Sin márgenes externos */\n}\n\n.content-container.padding-lg {\n  padding: var(--spacing-8);\n}\n\n/* Responsive padding adjustments */\n@media (max-width: 575px) {\n  .content-container.padding-sm {\n    padding: var(--spacing-3);\n  }\n\n  .content-container.padding-md {\n    padding: var(--spacing-4);\n  }\n\n  .content-container.padding-lg {\n    padding: var(--spacing-6);\n  }\n}\n\n@media (min-width: 576px) and (max-width: 1023px) {\n  .content-container.padding-sm {\n    padding: var(--spacing-4);\n  }\n\n  .content-container.padding-md {\n    padding: var(--spacing-5);\n  }\n\n  .content-container.padding-lg {\n    padding: var(--spacing-6);\n  }\n}\n\n/* Smooth scrolling */\n.content-container {\n  scroll-behavior: smooth;\n}\n\n/* Ensure proper height calculation */\n.content-container[style*=\"max-height\"] {\n  height: auto;\n}\n\n/* Force children to take full width */\n.content-container > * {\n  width: 100% !important;\n  max-width: 100% !important;\n  box-sizing: border-box;\n}\n\n/* Specifically target div.mt-4 and router-outlet inside content-container */\n.content-container .mt-4,\n.content-container router-outlet {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  display: block !important;\n  box-sizing: border-box !important;\n}\n\n/* Force app-tutorials and all its children to full width */\n.content-container app-tutorials,\n.content-container app-tutorials > * {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  box-sizing: border-box !important;\n}\n\n/* Force blockchain and euros components to full width */\n.content-container app-blockchain,\n.content-container app-blockchain > *,\n.content-container app-euros,\n.content-container app-euros > * {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  box-sizing: border-box !important;\n}\n\n/* Force my-profile child components to full width */\n.content-container app-investment-method,\n.content-container app-investment-method > *,\n.content-container app-user,\n.content-container app-user > *,\n.content-container app-configuration,\n.content-container app-configuration > *,\n.content-container app-change-password,\n.content-container app-change-password > * {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  box-sizing: border-box !important;\n}\n\n/* Asegurar que TODOS los content-containers mantengan bordes redondeados y sombra */\n/* Esta regla tiene máxima prioridad para garantizar consistencia visual */\n.content-container,\n.content-container.scrollbar-custom,\n.content-container.padding-md,\n.content-container.padding-sm,\n.content-container.padding-lg,\n.content-container.padding-none,\n.content-container.variant-default,\n.content-container.variant-dark,\n.content-container.route-usuario,\n.content-container.route-metodo-inversion,\n.content-container.route-resumen-financiero,\n.content-container.route-documentos,\n.content-container.menu-collapsed,\napp-content-container .content-container,\napp-content-container > .content-container {\n  border-radius: 12px;\n  box-shadow: 0 2px 8px var(--color-shadow-light) !important;\n}\n\n\n/* Override: cuando variant-white está activo, NO aplicar la sombra global */\n/* La sombra \"0 2px 8px ...\" proyecta ~6px hacia arriba del elemento, generando una */\n/* línea fantasma justo bajo el navbar en rutas con fondo blanco (cartera-digital/euros, etc.). */\n/* Selectores triple-clase para ganar especificidad sobre la regla anterior. */\n.content-container.variant-white,\n.content-container.scrollbar-custom.variant-white,\n.content-container.padding-md.variant-white,\n.content-container.padding-sm.variant-white,\n.content-container.padding-lg.variant-white,\n.content-container.padding-none.variant-white,\n.content-container.scrollbar-custom.padding-md.variant-white,\n.content-container.scrollbar-custom.padding-sm.variant-white,\n.content-container.scrollbar-custom.padding-lg.variant-white,\n.content-container.scrollbar-custom.padding-none.variant-white,\napp-content-container .content-container.variant-white,\napp-content-container > .content-container.variant-white {\n  box-shadow: none !important;\n}\n\n/* Adjust container width for specific routes */\n/* Método de inversión - ocupa todo el ancho */\n.content-container.route-metodo-inversion,\n.content-container.scrollbar-custom.route-metodo-inversion,\n.content-container.padding-md.route-metodo-inversion {\n  width: 100% !important; /* Ocupa todo el ancho */\n  max-width: none !important; /* Sin límite máximo */\n  margin: 0 !important;\n  border-radius: 12px; /* Mantener bordes redondeados */\n  box-shadow: 0 2px 8px var(--color-shadow-light) !important; /* Mantener sombra */\n}\n\n/* Usuario - limita el ancho máximo pero ocupa todo si es menor */\n.content-container.route-usuario,\n.content-container.scrollbar-custom.route-usuario,\n.content-container.padding-md.route-usuario,\n.content-container.variant-default.route-usuario {\n  width: 100% !important; /* Ocupa todo el ancho disponible */\n  max-width: 800px !important; /* Limita el ancho máximo solo si es necesario */\n  margin: 0 auto !important; /* Centra si es más estrecho que el contenedor */\n  border-radius: 12px; /* Mantener bordes redondeados */\n  box-shadow: 0 2px 8px var(--color-shadow-light) !important; /* Mantener sombra */\n}\n\n/* Dashboard - Resumen Financiero y Documentos - ocupa todo el ancho */\n.content-container.route-resumen-financiero,\n.content-container.scrollbar-custom.route-resumen-financiero,\n.content-container.padding-md.route-resumen-financiero,\n.content-container.route-documentos,\n.content-container.scrollbar-custom.route-documentos,\n.content-container.padding-md.route-documentos {\n  width: 100% !important; /* Ocupa todo el ancho */\n  margin: 0 !important;\n  border-radius: 12px; /* Mantener bordes redondeados */\n  box-shadow: 0 2px 8px var(--color-shadow-light) !important; /* Mantener sombra */\n}\n\n/* Support for menu-collapsed class from referral-panel */\n.content-container.menu-collapsed {\n  width: 100% !important; /* Ocupa todo el ancho del contenedor padre */\n  padding: 0px 60px 0px 60px !important;\n  margin: 0 !important;\n  border-radius: 12px; /* Mantener bordes redondeados */\n  box-shadow: 0 2px 8px var(--color-shadow-light) !important; /* Mantener sombra */\n  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n@media screen and (max-width: 1324px) {\n  .content-container.menu-collapsed {\n    width: 100% !important;\n    padding: 0px 40px 0px 40px !important;\n    margin: 0 !important;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px var(--color-shadow-light) !important;\n  }\n}\n\n/* ============================================================\n   MOBILE OVERRIDE — este bloque va AL FINAL para ganar siempre\n   en cascada sobre todas las reglas de ruta y alta especificidad.\n   En mobile el border-radius y la sombra los gestiona\n   navbar-router-container. El content-container hereda altura.\n   ============================================================ */\n@media screen and (max-width: 767px) {\n  .content-container,\n  .content-container.scrollbar-custom,\n  .content-container.padding-md,\n  .content-container.padding-sm,\n  .content-container.padding-lg,\n  .content-container.padding-none,\n  .content-container.variant-default,\n  .content-container.variant-white,\n  .content-container.variant-dark,\n  .content-container.route-usuario,\n  .content-container.scrollbar-custom.route-usuario,\n  .content-container.padding-md.route-usuario,\n  .content-container.variant-default.route-usuario,\n  .content-container.route-metodo-inversion,\n  .content-container.scrollbar-custom.route-metodo-inversion,\n  .content-container.padding-md.route-metodo-inversion,\n  .content-container.route-resumen-financiero,\n  .content-container.scrollbar-custom.route-resumen-financiero,\n  .content-container.padding-md.route-resumen-financiero,\n  .content-container.route-documentos,\n  .content-container.scrollbar-custom.route-documentos,\n  .content-container.padding-md.route-documentos,\n  .content-container.menu-collapsed,\n  app-content-container .content-container,\n  app-content-container > .content-container {\n    border-radius: 0 !important;\n    box-shadow: none !important;\n    min-height: 0 !important;\n    max-height: 100% !important;\n    height: 100% !important;\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
